export const NAVIGATION = 'cp_navigation'
export const FILES = 'cp_files'
export const AXIOS_ERROR_MESSAGE = 'cp_axios_error_message'
export const COPY_TO_CLIPBOARD = 'cp_copy_to_clipboard'
export const MUI_GRID = 'cp_mui_grid'
export const FILTERS = 'cp_filters'
export const TABLE_COMPONENT = 'cp_table';
export const PRODUCT_DETAIL = 'cp_product_details';
export const CONFIRMATION = 'cp_confirmation';